import { useEffect, useState } from 'react';

interface IDynamicImageWokBox {
  urlChunk: string;
  alt: string;
  className?: string;
}

function DynamicImageWokBox({ urlChunk, alt, ...props }: IDynamicImageWokBox) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    import(`assets/images/wok-box/${urlChunk}.png`)
      .then((response) => {
        setSrc(response.default);
      })
      .catch(console.warn);
  }, [urlChunk]);

  if (!src) {
    return null;
  }
  return <img src={src} alt={alt} {...props} />;
}

export default DynamicImageWokBox;
